// extracted by mini-css-extract-plugin
export var bullet = "_mv-q";
export var bulletText = "_mv-p";
export var bullets = "_mv-k";
export var callout = "_mv-g";
export var calloutBody = "_mv-i";
export var calloutLabel = "_mv-h";
export var checkIcon = "_mv-m";
export var checkList = "_mv-j";
export var checkSvg = "_mv-n";
export var checkText = "_mv-o";
export var fieldCard = "_mv-1";
export var fieldDescription = "_mv-5";
export var fieldHeader = "_mv-3";
export var fieldTitle = "_mv-4";
export var finalNote = "_mv-s";
export var flow = "_mv-x";
export var flowArrow = "_mv-v";
export var flowStep = "_mv-u";
export var helperText = "_mv-r";
export var inlineTitle = "_mv-t";
export var listItem = "_mv-l";
export var noteBody = "_mv-8";
export var noteBodyText = "_mv-9";
export var noteCard = "_mv-2";
export var noteIcon = "_mv-6";
export var noteTitle = "_mv-7";
export var productChoices = "_mv-w";
export var radioDot = "_mv-d";
export var radioDotSelected = "_mv-e";
export var radioDotSvg = "_mv-f";
export var selectableCard = "_mv-b";
export var selectableCardSelected = "_mv-c";
export var strongText = "_mv-a";
export var subHeading = "_mv-0";